export default __webpack_public_path__ + "static/media/boa-logo.dd47d639.png";